import _ from 'lodash';
import { createSelector } from 'reselect';

import searchItems from 'utils/searchItems';

import { getIsFromInternalCompany } from 'store/auth/selectors';
import { getDebouncedSearchValue } from 'store/search/selectors';

import { getSystem } from './system.selectors';

export const selectProgramIdentifiers = createSelector(
  [getSystem, getIsFromInternalCompany],
  ({ programIdentifiers }, isInternalCompany) =>
    _.reduce(
      programIdentifiers,
      (acc, i) => {
        acc[i.id] = {
          ...i,
          ...(_.isBoolean(isInternalCompany) && { isGlobal: !isInternalCompany && i.isGlobal }),
        };

        return acc;
      },
      {},
    ),
);

export const selectProgramIdentifiersValues = createSelector(
  [selectProgramIdentifiers],
  programIdentifiers =>
    _.sortBy(programIdentifiers, [({ type }) => _.toLower(type), ({ name }) => _.toLower(name)]),
);

export const selectProgramIdentifiersOptions = createSelector(
  [selectProgramIdentifiersValues],
  programIdentifiers => programIdentifiers.map(({ name, id }) => ({ name, value: id })),
);

export const selectFilteredProgramIdentifiers = createSelector(
  getDebouncedSearchValue,
  selectProgramIdentifiersValues,
  searchItems(programIdentifiers => [programIdentifiers.name]),
);
